class Phone {
  constructor(code, imei, numberPlate, ecgCode, stationId, phoneTypeId) {
    this.code = code;
    this.imei = imei;
    this.numberPlate = numberPlate;
    this.ecgCode = ecgCode;
    this.stationId = stationId;
    this.phoneTypeId = phoneTypeId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      phoneId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      searchModal: false,
      isSearch: false,
      modalIcon: '',
      phoneManagmentInformationTableHeaders: [
        { text: 'کد', value: 'code', align: 'center' },
        { text: 'شناسه گوشی', value: 'phoneToken', align: 'center' },
        { text: 'شماره سیم کارت', value: 'phoneNumber', align: 'center' },
        {
          text: 'ورژن نرم افزار',
          value: 'applicationVersion',
          align: 'center',
        },
        { text: 'نوع وسیله نقلیه', value: 'vehicleType', align: 'center' },
        { text: 'پایگاه', value: 'station', align: 'center' },
        { text: 'APN', value: 'apn', align: 'center' },
        { text: 'موقعیت', value: 'location', align: 'center' },
        { text: 'وضعیت', value: 'status', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      statusSearchListItems: [
        { text: 'هیچکدام', id: 1 },
        { text: 'عملیاتی', id: 2 },
        { text: 'غیر عملیاتی', id: 3 },
      ],
      isActiveSearchListItems: [
        { text: 'هیچکدام', id: 1 },
        { text: 'فعال', id: 2 },
        { text: 'غیر فعال', id: 3 },
      ],
      useApnSearchListItems: [
        { text: 'هیچکدام', id: 1 },
        { text: 'فعال', id: 2 },
        { text: 'غیر فعال', id: 3 },
      ],
      searchCode: '',
      searchPhoneToken: '',
      searchUseAPN: 1,
      searchIsActive: 1,
      searchIsBroken: 1,
      searchIPAddress: null,
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن گوشی';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش گوشی';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getPhoneFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.phone = new Phone('', '', '', false, null, null, '', false, null, null, false, null);
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addPhoneFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش گوشی';
        this.$refs.confirm.text = 'از ویرایش گوشی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف گوشی';
        this.$refs.confirm.text = 'از حذف گوشی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType === 'activate') {
        this.$refs.confirm.title = 'فعال کردن گوشی';
        this.$refs.confirm.text = 'از فعال این گوشی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType === 'deactivate') {
        this.$refs.confirm.title = 'غیرفعال کردن گوشی';
        this.$refs.confirm.text = 'از غیرفعال این گوشی اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addPhoneFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editPhoneFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deletePhoneFunction();
      } else if (this.confimType === 'activate') {
        this.disabelConfirm = true;
        this.activatePhone();
      } else if (this.confimType === 'deactivate') {
        this.disabelConfirm = true;
        this.deactivatePhone();
      }
    },
    confirmDialogCancelFunction: function () {
      this.$refs.confirm.showConfirmDialog = false;
      this.disabelConfirm = false;
      if (this.confimType.includes('activate')) this.getListOfPhonesWithPagination();
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.phoneId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    // change status
    showChangeConfirmation: function (id, isActive) {
      this.phoneId = id;
      if (isActive) this.confimType = 'deactivate';
      else this.confimType = 'activate';
      this.showConfirmDialogFunction();
    },
    //search
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getListOfPhonesWithPagination();
    },
    removeFilters: function () {
      this.searchPhoneToken = '';
      this.searchUseAPN = 1;
      this.searchIsActive = 1;
      this.searchIsBroken = 1;
      this.searchIPAddress = '';
      this.searchCode = '';
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getListOfPhonesWithPagination();
    },
    cancelSearch: function () {
      this.searchPhoneToken = '';
      this.searchUseAPN = 1;
      this.searchIsActive = 1;
      this.searchIsBroken = 1;
      this.searchIPAddress = '';
      this.searchCode = '';
      this.searchModal = false;
    },
  },
};
